import { Component, OnDestroy, OnInit } from '@angular/core';
import { catchError, EMPTY, Subscription } from 'rxjs';
import { NewsService } from '../news.service';
import { NewsSlideoutService } from '../news-slideout/news-slideout.service';

@Component({
    selector: 'app-slipcase-news-list',
    templateUrl: './slipcase-news-list.component.html',
    styleUrls: ['./slipcase-news-list.component.sass'],
    standalone: false
})
export class SlipcaseNewsListComponent implements OnInit, OnDestroy {
  newsItems: any[] = [];
  loading: boolean = true;
  error: boolean = false;
  newsSub: Subscription = new Subscription();

  constructor(private newsService: NewsService) { }

  ngOnInit(): void {
    this.newsSub = this.newsService.getNews()
      .pipe(catchError(() => {
        this.error = true;
        this.loading = false;
        return EMPTY;
      }))
      .subscribe(data => {
        this.error = false;
        this.newsItems = data;
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.newsSub.unsubscribe();
  }
}
